import * as types from "./historico.actionTypes";

export default {
  closeModalHistorico: () => ({
    type: types.MODAL_HISTORICO_CLOSE
  }),
  openModalHistorico: () => ({
    type: types.MODAL_HISTORICO_OPEN
  }),
  closeModalHistorico: () => ({
    type: types.MODAL_HISTORICO_CLOSE
  }),
  setHistorico: data => ({
    type: types.SET_HISTORICO,
    payload: data
  }),
  addSagaHistorico: data => ({
    type: types.ADD_SAGA_HISTORICO,
    payload: data
  }),
  addHistorico: data => ({
    type: types.ADD_HISTORICO,
    payload: data
  }),
  deleteSagaHistorico: data => ({
    type: types.DELETE_SAGA_HISTORICO,
    payload: data
  }),
  deleteHistorico: data => ({
    type: types.DELETE_HISTORICO,
    payload: data
  }),
}
